module.exports = __webpack_public_path__ + "static/media/folder.7d19ca92.webp";